import apiClient from 'utilities/apiClient';

export const stocks = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.stocks}/${url}`, payload, true);
};
